import { qltClient } from '../clients';
import { Repository } from '../core/repository';
import type { QltSlot } from '../types';

export const SlotRepository = Repository<QltSlot>(qltClient, '/slots');

export default SlotRepository;
